import { Icon, SegmentedProgressBar, Text } from '@pm/ui';
import { useToggle } from '@pm/util';
import { useTranslation } from 'react-i18next';
import {
  ShipmentLike,
  useShipmentStatus,
} from '../../../hooks/use-shipment-status/useShipmentStatus';
import { LabKitShipmentModal } from '../LabKitShipmentModal';
import { TrackingStep } from './types';

type TrackingSectionProps = {
  step: TrackingStep;
  outboundShipment: ShipmentLike | null;
  inboundShipment: ShipmentLike | null;
  supportLink: string;
};

export const TrackingSection = ({
  step,
  outboundShipment,
  inboundShipment,
  supportLink,
}: TrackingSectionProps) => {
  const { t } = useTranslation('labs');
  const [showModal, handlers] = useToggle();
  const { status, description, trackingNumber, shouldShowSupportLink } =
    useShipmentStatus({ inboundShipment, outboundShipment });

  const ctaLabel =
    step < 4 ? t('HeroCard.Track') : t('HeroCard.ViewTrackingHistory');

  return (
    <>
      <div className="space-y-xs pt-xl">
        <button
          type="button"
          onClick={handlers.on}
          className="inline-flex items-center gap-xxs text-content-link font-medium hover:text-content-link-hover focus:outline-hidden focus:ring-2 focus:ring-brand-primary-200 group"
        >
          <span className="group-hover:underline">{ctaLabel}</span>
          <Icon name="arrow_forward" size="small" />
        </button>
        <SegmentedProgressBar
          step={step}
          aria-label={t('HeroCard.TrackingProgressLabel')}
        />
        <Text size="bodyS" color="contentSubdued">
          {t(`HeroCard.TrackingCopy.Step${step}`)}
        </Text>
      </div>
      <LabKitShipmentModal
        status={status}
        description={description}
        trackingNumber={trackingNumber}
        isOpen={showModal}
        onClose={handlers.off}
        supportLink={supportLink}
        shouldShowSupportLink={shouldShowSupportLink}
      />
    </>
  );
};
